import { ChangeDetectorRef, Component, QueryList, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import {catchError, firstValueFrom, map, Observable, of} from 'rxjs';
import { DecimalPipe, DatePipe, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ArticleService } from './services/article.service';
import { Article } from '../shared/models/article.interface';
import { NgbdSortableHeader, SortEvent } from './services/sortable.directive';
import { ShapeService } from '../model-viewer/shape.service';
import { AuthService } from '../shared/auth-service/auth.service';
import { Endpoints, ArticlePushObject, ArticleVerifyObject } from './services/article.models';
import { AppToastService } from '../shared/toast-service/toast-service';
import { HttpParams } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Router, RouterEvent } from '@angular/router';
import { System } from '../shared/models/thermal-methods/System.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
interface SystemArticles {
  system: string;
  articles: Article[];
  showTable: boolean;
}
@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss'],
  providers: [DatePipe],
  standalone: false,
})
export class ArticlesComponent {
  public loggedIn!: boolean;
  title = 'Article Staging';
  closeResult = '';
  modalContent: Article | undefined;
  articles$: any;
  displayError: boolean = false;
  errorMessage: string = '';
  threeJsModelUrl: string = '';
  pdfSrc: string = 'https://article-data-files-dev.s3.amazonaws.com/540870-3D.pdf';
  systemArticleMap: { system: string, articles: Article[], showTable: boolean }[] = [];
  applicationSystemArticleMap: { Application: string, SystemNames: any[], showApplicationTable: boolean }[] = [];
  loadedArticles: { [key: string]: { articles: Article[], showTable: boolean } } = {};
  // searchResults: { [system: string]: { articles: Article[], showTable: boolean } } = {};
  searchResults: any[] = [];
  formattedDate: string = '';
  filterOptions = [
    { label: 'Need Designer Review', selected: false },
    { label: 'Need Engineer Review', selected: false },
    { label: 'Verified By Designer', selected: false },
    { label: 'Verified By Engineer', selected: false }
  ];
  // This will hold the selected filter options.
  selectedFilters: any[] = [];
  selectedFilterValue: string[] = [];
  loading: boolean = false;
  articlesSectionBySystem: Article[] = [];
  modalContentPresignedUrl: string = '';
  jsUrl: string = '';
  jsUrlList: string[] = [];


  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;

  constructor(
    private modalService: NgbModal,
    public articleService: ArticleService,
    private shapeService: ShapeService,
    private authService: AuthService,
    private toastService: AppToastService,
    private router: Router,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.loggedIn = this.isLoggedIn();
    this.articles$ = this.articleService.articles$;
    this.getSystemArticleMap();
  }

  // async navigateToArticleViewer(articles: Article[]) {
  //   const jsUrls: string[] = [];
  //   articles.forEach(article => {
  //     const url = this.correctUrl(article.ThreeJSFileStoragePath, article.ArticleName);
  //     this.correctUrl(article.ThreeJSFileStoragePath, article.ArticleName).subscribe(url => {
  //       console.log('url', url);
  //       jsUrls.push(url);
  //       this.jsUrlList = jsUrls;
  //     });
  //   });
  //   console.log('jsUrls', jsUrls);
  //   await this.router.navigate(['/article-viewer'], { state: { data: this.jsUrlList } });
  // }

  async navigateToArticleViewer(articles: Article[]) {
    debugger
    // Check if any article has empty ThreeJSFileStoragePath
    const articlesWithoutThreeJS = articles.filter(article => !article.ThreeJSFileStoragePath || article.ThreeJSFileStoragePath.trim() === '');
    
    if (articlesWithoutThreeJS.length > 0) {
      // Show error message instead of navigating
      const articleNames = articlesWithoutThreeJS.map(article => article.ArticleName || 'Unknown Article').join(', ');
      const errorMessage = articlesWithoutThreeJS.length === 1 
        ? `Article "${articleNames}" does not have a 3D model file (ThreeJSFileStoragePath is empty).`
        : `The following articles do not have 3D model files: ${articleNames}`;
      
      this.showError(errorMessage);
      
      // Also show toast notification
      this.toastService.show(errorMessage, { 
        classname: 'bg-danger text-light', 
        delay: 5000,
        autohide: true 
      });
      
      return;
    }
    
    // Proceed with navigation if all articles have ThreeJSFileStoragePath
    const promises = articles.map(async article => {
      return firstValueFrom(
        this.correctUrl(article.ThreeJSFileStoragePath, article.ArticleName)
      );
    });
    const jsUrls = await Promise.all(promises);
    // Store data in sessionStorage for cross-tab access
    sessionStorage.setItem('articleViewerData', JSON.stringify(jsUrls));
    // Open in new tab
    window.open('/article-viewer', '_blank');
  }

  private getSystemArticleMap(): void {
    this.articleService.getSystemArticleMap().subscribe(applicationSystemArticleMap => {
      this.applicationSystemArticleMap = applicationSystemArticleMap;
      console.log('applicationSytemTypes', this.applicationSystemArticleMap);
    });
  }

  // loadArticles(system: any): void {
  //   // Load articles only when system is clicked
  //   if (!this.loadedArticles[system]) {
  //     this.articleService.getArticlesBySystem(system).subscribe(articles => {
  //       this.loadedArticles[system] = articles;
  //       system.articles = articles;  // Assign articles to system
  //       system.showTable = true;     // Show the table
  //     });
  //   } else {
  //     system.showTable = !system.showTable;  // Toggle table visibility if already loaded
  //   }
  // }

  upload() {
    console.log('uploading');
  }

  /**
   * Opens the modal to select a DXF file for upload, confirm the file selected, and upload file.
   */
  openDxfImport(dxfImportModal: any) {
    this.modalService
      .open(dxfImportModal, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'fluid-modal',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  loadArticles(system: string): void {
    this.loading = true;
    // If articles for this system are not loaded yet
    if (!this.loadedArticles[system]) {
      const systemApiModel = {
        systemName: system // Structure matches the API model
      };
      this.articleService.getArticlesBySystem(systemApiModel).subscribe(articles => {
        // Store the articles and initialize showTable to true
        this.loadedArticles[system] = { articles: articles, showTable: true };
        this.articlesSectionBySystem = articles;
        console.log('loadedArticles', this.loadedArticles);
        this.loadedArticles[system].articles.forEach(article => {
          article.updatedFormattedDate = this.datePipe.transform(article.updatedAt, 'MMM-dd-yyyy  hh:mm a') || '';
        });
        this.loading = false;
      });
    } else {
      // Toggle showTable property for this system
      this.loadedArticles[system].showTable = !this.loadedArticles[system].showTable;
      this.loading = false;
    }
  }

  // applyFilter(filter: any) {
  //   filter.selected = !filter.selected;
  //   this.selectedFilters = this.filterOptions.filter(f => f.selected).map(f => f.label);
  //   this.search();
  // }

  // This method is called when a checkbox changes
  onFilterChange(filter: any, event: Event) {
    filter.selected = (event.target as HTMLInputElement).checked; // Update the selected state based on checkbox
    // this.getSelectedFilteredArticlesList();
    this.updateSelectedFilters(); // Optionally update selected filters
  }

  // This method removes the selected filter
  removeFilter(filter: any) {
    filter.selected = false; // Deselect the filter
    this.updateSelectedFilters(); // Optionally update selected filters
  }

  // This method can be used to log or handle selected filters
  updateSelectedFilters() {
    this.selectedFilterValue = [];
    this.selectedFilters = this.filterOptions.filter(f => f.selected);
    if (this.selectedFilters.length > 0) {
      this.selectedFilterValue = this.selectedFilters.map(s => s.label); // Use map to directly create the array
      const filterApiModel = {
        filterOptions: this.selectedFilterValue // Structure matches the API model
      };
      this.articleService.getFilteredArticles(filterApiModel).subscribe(articles => {
        this.searchResults = [];
        this.searchResults = articles;

        this.searchResults.forEach(article => {
          article.systemNames.forEach((sys: any) => {
            sys.articles.forEach((art: Article) => {
              art.updatedFormattedDate = this.datePipe.transform(art.updatedAt, 'MMM-dd-yyyy  hh:mm a') || '';
            });
          });
        });
        if (this.searchResults.length == 0) {
          this.toastService.show('No articles found with the applied filter.', { classname: 'bg-danger text-light', delay: 4000 });
        }
      }, error => {
        if (this.searchResults.length == 0) {
          this.toastService.show('No articles found with the applied filter.', { classname: 'bg-danger text-light', delay: 4000 });
        }

      });
    } else {
      this.searchResults = [];
    }
  }

  // Method to get selected filters
  getSelectedFilters() {
    return this.filterOptions.filter(filter => filter.selected);
  }

  search(event: Event): void {
    event.preventDefault();
    if (this.articleService.searchTerm) {
      this.articleService.searchArticlesOrSystems(this.articleService.searchTerm).subscribe(articles => {
        //this.applicationSystemArticleMap = this.articleService.convertToMap(data);
        //this.applicationSystemArticleMap = data;

        // Clear existing search results
        this.searchResults = [];
        this.searchResults = articles;
        // Group articles by system (just like `loadedArticles`)
        articles.forEach(article => {
          const systemName = article.systemName || 'unKnown';
        });

        this.searchResults.forEach(article => {
          article.systemNames.forEach((sys: any) => {
            sys.articles.forEach((art: Article) => {
              art.updatedFormattedDate = this.datePipe.transform(art.updatedAt, 'MMM-dd-yyyy  hh:mm a') || '';
            });
          });
        });
      }, error => {
        if (this.searchResults.length == 0) {
          this.toastService.show('No matching article or system found.', { classname: 'bg-danger text-light', delay: 4000 });
        }
      });
    } else {
      this.searchResults = [];
    }
  }



  private isLoggedIn() {
    return !!this.authService.getToken();
  }

  public logout() {
    this.authService.logout();
  }

  /**
   * Sorts the table by the specified column.
   * @param param0 column and direction to sort by
   */
  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.articleService.sortColumn = column;
    this.articleService.sortDirection = direction;
  }

  pushArticle(article: Article, endpoint: string, systemName: string) {
    const articlePushObject: ArticlePushObject = {
      ArticleName: article.ArticleName,
      environment: endpoint,
      systemName: systemName
    };

    this.articleService.pushArticle(articlePushObject).subscribe({
      next: (response) => {
        this.toastService.show('Article pushed successfully to ' + endpoint, { classname: 'bg-success text-light', delay: 4000 });
      },
      error: (error) => {
        console.log(error);
        this.showError("Could not push article.");
      }
    });
  }

  pushSystem(systemName: string, endpoint: string) {
    this.articleService.pushSystem(systemName, endpoint).subscribe({
      next: (response) => {
        this.toastService.show('Article pushed successfully to ' + endpoint, { classname: 'bg-success text-light', delay: 4000 });
      },
      error: (error) => {
        console.log(error);
        this.showError("Could not push article.");
      }
    });
  }

  verifiedArticleByEngineer(article: Article) {
    const articleVerifyObject: ArticleVerifyObject = {
      ArticleName: article.ArticleName,
      SystemName: article.systemName ? article.systemName : null,
      ProfileType: article.ProfileType ? article.ProfileType : null,
      Country: article.country ? article.country : null
    }
    this.articleService.verifiedArticleByEngineer(articleVerifyObject).subscribe({
      next: (response) => {
        this.toastService.show('Article was verified by Engineer successfully', { classname: 'bg-success text-light', delay: 4000 })
      },
      error: (error) => {
        console.log(error);
        this.showError('could not verified article by Engineer.')
      }
    });
  }

  verifiedArticleByDesigner(article: Article) {
    const articleVerifyObject: ArticleVerifyObject = {
      ArticleName: article.ArticleName,
      SystemName: article.systemName ? article.systemName : null,
      ProfileType: article.ProfileType ? article.ProfileType : null,
      Country: article.country ? article.country : null
    }
    this.articleService.verifiedArticleByDesigner(articleVerifyObject).subscribe({
      next: (response) => {
        this.toastService.show('Article was verified by Engineer successfully', { classname: 'bg-success text-light', delay: 4000 })
      },
      error: (error) => {
        console.log(error);
        this.showError('could not verified article by Designer.')
      }
    });
  }

  issuesIdentifiedByEngineer(article: Article) {
    const articleVerifyObject: ArticleVerifyObject = {
      ArticleName: article.ArticleName,
      SystemName: article.systemName ? article.systemName : null,
      ProfileType: article.ProfileType ? article.ProfileType : null,
      Country: article.country ? article.country : null
    }
    this.articleService.issuesIdentifiedByEngineer(articleVerifyObject).subscribe({
      next: (response) => {
        this.toastService.show('Article issues was identified by Engineer', { classname: 'bg-success text-light', delay: 4000 })
      },
      error: (error) => {
        console.log(error);
        this.showError('could not identified article issues by Engineer.')
      }
    });
  }

  issuesIdentifiedByDesigner(article: Article) {
    const articleVerifyObject: ArticleVerifyObject = {
      ArticleName: article.ArticleName,
      SystemName: article.systemName ? article.systemName : null,
      ProfileType: article.ProfileType ? article.ProfileType : null,
      Country: article.country ? article.country : null
    }
    this.articleService.issuesIdentifiedByDesigner(articleVerifyObject).subscribe({
      next: (response) => {
        this.toastService.show('Article issues was identified by Designer', { classname: 'bg-success text-light', delay: 4000 })
      },
      error: (error) => {
        console.log(error);
        this.showError('could not identified article issues by Designer.')
      }
    });
  }

  deleteArticle(article: any) {
    this.articleService.deleteArticle(article.systemName, article.ArticleName).subscribe({
      next: (response) => {
        this.toastService.show(article.ArticleName + ' of ' + article.systemName + ' deleted successfully', { classname: 'bg-success text-light', delay: 4000 });
      },
      error: (error) => {
        console.log(error);
        this.showError("Could not delete article.");
      }
    });
  }
  /**
 * Opens the modal and displays the sectional Properties.
 * @param modal modal to open
 * @param article article containing sectional Properties to render
 */
  openSectionalPropertiesModal(modal: any, article: Article) {
    this.modalContent = article;
    this.modalService
      .open(modal, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'fluid-modal',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  /**
  * Opens the modal and displays the exception message.
  * @param modal modal to open
  * @param article article containing exception message to render
  */
  openExceptionModal(modal: any, article: Article) {
    this.modalContent = article;
    this.modalService
      .open(modal, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'fluid-modal',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  // sanitizeExceptionMessage(message: string | null | undefined): SafeHtml {
  //   return this.sanitizer.bypassSecurityTrustHtml((message || '').replace(/\n/g, '<br>'));
  // }

  // sanitizeExceptionMessage(message: string | null | undefined): SafeHtml {
  //   if (!message) {
  //     return '';
  //   }

  //   // Replace `\n` with `<br>` and make specific words bold
  //   const formattedMessage = message
  //     .replace(/\n/g, '<br>') // Convert new lines
  //     .replace(/(Sectional Properties:)/g, '<b>$1</b>') // Bold "Sectional Properties:"
  //     .replace(/(ThreeJS File:)/g, '<b>$1</b>') // Bold "ThreeJs File:"
  //     .replace(/(Article Image:)/g, '<b>$1</b>'); // Bold "Article Image:"

  //   return this.sanitizer.bypassSecurityTrustHtml(formattedMessage);
  // }

  sanitizeExceptionMessage(message: string | null | undefined): SafeHtml {
    if (!message) {
      return '';
    }

    // Convert new lines to <br> and bold section names
    const formattedMessage = message
      .replace(/\n/g, '<br>') // Convert new lines
      .replace(/(Sectional Properties:)/g, '<b>$1</b>') // Bold "Sectional Properties"
      .replace(/(ThreeJS File:)/g, '<b>$1</b>') // Bold "ThreeJs File"
      .replace(/(Article Image:)/g, '<b>$1</b>') // Bold "Article Image"
      .replace(/(Article Image:.*?)(<br>|$)/gs, '$1<br><hr>') // Add <hr> after "Article Image" section
      .replace(/(ThreeJS File:.*?)(<br>|$)/gs, '$1<br><hr>') // Add <hr> after "ThreeJs File" section
      .replace(/(Sectional Properties:.*?)(<br>|$)/gs, '$1<br><hr>'); // Add <hr> after "Sectional Properties" section

    return this.sanitizer.bypassSecurityTrustHtml(formattedMessage);
  }

  /**
* Opens the modal and displays the image.
* @param modal modal to open
* @param article article containing image to render
*/
  opensLogicModal(modal: any, article: Article) {
    this.modalContent = article;
    this.modalService
      .open(modal, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'fluid-modal',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  /**
   * Opens the modal and displays the image.
   * @param modal modal to open
   * @param article article containing image to render
   */
  openImageViewerModal(modal: any, article: Article) {
    this.modalContent = article;
    // Fetch presigned URL
    if (article?.ImageStoragePath && article?.ArticleName) {
      const extension = this.extractFileExtension(article.ImageStoragePath);
      const fileName = `${article.ArticleName}${extension}`;

      this.articleService.getPresignedURL(fileName, 'Image').subscribe({
        next: (url) => { console.log('ImageUrl', url); this.modalContentPresignedUrl = url },
        error: (err) => {
          console.error(err);
          this.showError("Could not get presigned URL for image.");
          this.modalContentPresignedUrl = ''; // fallback
        }
      });
    } else {
      this.modalContentPresignedUrl = '';
    }
    this.modalService
      .open(modal, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'fluid-modal',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  openDxfImageViewerModal(modal: any, article: Article) {
    this.modalContent = article;
    this.modalService
      .open(modal, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'fluid-modal',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
  }


  /**
   * Opens the modal and displays the image.
   * @param modal modal to open
   * @param article article containing image to render
   */
  open3DPDF(modal: any, article: Article) {
    this.modalContent = article;
    this.modalService
      .open(modal, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'fluid-modal',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  /**
   * Opens the modal and displays the three.js model.
   * @param modal modal to open
   * @param article article containing model to render
   */
  openJsViewerModal(modal: any, article: Article) {
  this.modalContent = article;

    this.correctUrl(article.ThreeJSFileStoragePath, article.ArticleName).subscribe(finalUrl => {
      console.log("Final URL:", finalUrl);
      this.jsUrl = finalUrl;   //  Pass to model viewer

      //  Only open modal after URL is ready
      this.modalService
        .open(modal, {
          ariaLabelledBy: 'modal-basic-title',
          fullscreen: true
        })
        .result.then(
          (result) => {
            this.closeResult = `Closed with: ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
    });
  }

  openThreeJs(article: Article, event: Event) {
    event.preventDefault(); // prevent navigating to "#"

  this.articleService.getPresignedURL('article__'+article.ArticleName+'.js', '3js')
    .subscribe(url => {
      window.location.href = url; //  replaces current tab with the file
    });
}

  openDxf(article: Article, event: Event) {
    event.preventDefault(); // prevent navigating to "#"

  this.articleService.getPresignedURL(article.ArticleName+'.dxf', 'dxf')
    .subscribe(url => {
      window.location.href = url; //  replaces current tab with the file
    });
}

  /**
   * Corrects the url for the three.js model.
   * This function is a workaround for the incorrect URLs in database.
   * @param url url to correct
   */
 correctUrl(url: string | undefined, articleName: string): Observable<string> {
  debugger
  const oldBucketPrefix = 'https://article-data-files.s3.amazonaws.com/';
  const newBucketPrefix = 'https://article-data-files-dev.s3.amazonaws.com/';
  
  if (url && url.startsWith(oldBucketPrefix)) {
    url = url.replace(oldBucketPrefix, newBucketPrefix);
  }
  const incorrectPrefix = "https://s3-.amazonaws.com/article-data-files/article-3js-files";
  const correctPrefix = "https://article-data-files-dev.s3.amazonaws.com/article-3js-files";

  if (url === undefined) {
    this.threeJsModelUrl = '';
    return of('');
  }

  if (url.startsWith(incorrectPrefix)) {
    const remainingUrlPart = url.substring(incorrectPrefix.length);
    const existingSixDigitNumber = this.extractSixDigitNumber(remainingUrlPart);

    let newURL: string;
    if (existingSixDigitNumber !== null) {
      newURL = `${correctPrefix}/article__${existingSixDigitNumber}${this.extractFileExtension(remainingUrlPart)}`;
    } else {
      newURL = this.ensurePrefixInURL(correctPrefix, remainingUrlPart);
    }

    this.threeJsModelUrl = newURL;
    return of(newURL);
  }

    if (url.startsWith(correctPrefix)) {
      // 🔑 Call backend to get presigned URL
      return this.articleService.getPresignedURL('article__'+ articleName +'.js', '3js').pipe(
        map((response: string) => {
          console.log('Presigned URL:', response);
          this.threeJsModelUrl = response;
          return response;
        }),
        catchError((error) => {
          console.error('Error fetching presigned URL:', error);
          this.threeJsModelUrl = '';
          return of('');
        })
      );
    }
     this.threeJsModelUrl = url;
  return of(url);
  }
  
  // Utility for `correctUrl()`.
  private ensurePrefixInURL(prefix: string, url: string): string {
    const regex = new RegExp(`^${prefix}/article__\\d{6}\\..+$`);
  
    if (!regex.test(url)) {
      return `${prefix}/article__${url}`;
    }
  
    return url;
  }
  
  // Utility for `correctUrl()`.
  private extractSixDigitNumber(input: string): string | null {
    const regex = /\d{6}/;
    const match = input.match(regex);
    return match ? match[0] : null;
  }
  
  // Utility for `correctUrl()`.
  private extractFileExtension(input: string): string {
    const parts = input.split('.');
    if (parts.length > 1) {
      return `.${parts.pop()}`;
    }
    return '';
  }

  /**
   * Handles modal dismissal.
   * @param reason reason for modal dismissal (how)
   */
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  /**
   * Dismisses the modal and clears the three.js scene.
   * @param modal modal to dismiss
   */
  dismissJsModal(modal: any) {
    modal.dismiss('Cross click');
    this.shapeService.clearScene();
  }

  /**
   * Displays error message inside of conditional alert.
   * @param message error message to display
   */
  showError(message: string) {
    this.displayError = true;
    this.errorMessage = message;
  }

  isBPSApp(application: string) {
    return application == "BPS";
  }

  isSRSApp(application: string) {
    return application == "SRS";
  }


  exportToExcel(systemName: any): void {
    this.loading = true;
    this.cdRef.detectChanges();

    const processExport = (articles: any[]) => {
      const propertiesToRemove = [
        'imageStoragePath', 'threeJSFileStoragePath', 'dxfStoragePath', 'createdAt',
        'updatedFormattedDate', 'updatedAt', 'isBPSDevDeployed', 'isBPSStagingDeployed',
        'isBPSProdDeployed', 'isArticleJSHasReview', 'exceptionMessage', 'isActive'
      ];

      const filteredArticles = articles.map((article: any) => {
        const filteredArticle = { ...article };
        propertiesToRemove.forEach(property => {
          delete filteredArticle[property];
        });
        return filteredArticle;
      });

      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredArticles);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

      saveAs(new Blob([wbout], { type: 'application/octet-stream' }), systemName + '.xlsx');
      this.loading = false;
    };

    if (this.loadedArticles[systemName]) {
      processExport(this.loadedArticles[systemName].articles);
    } else {
      const systemApiModel = { systemName: systemName };
      this.articleService.getArticlesBySystem(systemApiModel).subscribe(articles => {
        this.loadedArticles[systemName] = { articles: articles, showTable: false };
        processExport(articles);
      });
    }
  }

  downloadArticleImages(systemName: any) {
    let articles: any
    this.loading = true;
    this.cdRef.detectChanges();

    const processDownload = (articles: any[]) => {
      // Format dates
      articles.forEach(article => {
        article.updatedFormattedDate = this.datePipe.transform(article.updatedAt, 'MMM-dd-yyyy  hh:mm a') || '';
      });

      // Create image list
      const imageList = articles
        .filter((a: any) => a.ImageStoragePath)
        .map((article: any) => {
          const s3Key = this.extractS3Key(article.ImageStoragePath);
          const extension = this.extractFileExtension(article.ImageStoragePath);
          return {
            s3Key,
            fileName: `${article.ArticleName || 'image'}${extension}`
          };
        });

      // Download as zip
      this.articleService.downloadArtifactsAsZip(imageList).subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = systemName + '_Images.zip';
        a.click();
        window.URL.revokeObjectURL(url);
        this.loading = false;
      });
    };

    // If already loaded, use directly
    if (this.loadedArticles[systemName]) {
      processDownload(this.loadedArticles[systemName].articles);
    } else {
      // Load articles first
      const systemApiModel = { systemName: systemName };
      this.articleService.getArticlesBySystem(systemApiModel).subscribe(articles => {
        this.loadedArticles[systemName] = { articles: articles, showTable: false };
        processDownload(articles);
      });
    }
  }

  downloadThreeJsFiles(systemName: any) {
    this.loading = true;
    this.cdRef.detectChanges();

    const processDownload = (articles: any[]) => {
      // Format dates
      articles.forEach(article => {
        article.updatedFormattedDate = this.datePipe.transform(article.updatedAt, 'MMM-dd-yyyy  hh:mm a') || '';
      });

      // Create image list
      const threeJSList = articles
        .filter((a: any) => a.ThreeJSFileStoragePath)
        .map((article: any) => {
          const s3Key = this.extractS3Key(article.ThreeJSFileStoragePath);
          const extension = this.extractFileExtension(article.ThreeJSFileStoragePath);
          return {
            s3Key,
            fileName: `article__${article.ArticleName || 'article'}${extension}`
          };
        });

      // Download as zip
      this.articleService.downloadArtifactsAsZip(threeJSList).subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = systemName + '_ThreeJS.zip';
        a.click();
        window.URL.revokeObjectURL(url);
        this.loading = false;
      });
    };

    // If already loaded, use directly
    if (this.loadedArticles[systemName]) {
      processDownload(this.loadedArticles[systemName].articles);
    } else {
      // Load articles first
      const systemApiModel = { systemName: systemName };
      this.articleService.getArticlesBySystem(systemApiModel).subscribe(articles => {
        this.loadedArticles[systemName] = { articles: articles, showTable: false };
        processDownload(articles);
      });
    }
  }

  extractS3Key(url: string): string {
    return decodeURIComponent(new URL(url).pathname.substring(1)); // removes leading "/"
  }

  getImagePresignedUrl(url: string, articleName: string): any {
    const extension = url != null ? this.extractFileExtension(url) : '';
    if (!url) return '';
    const fileName = `${articleName}${extension}`;
    this.articleService.getPresignedURL(fileName, 'Image').subscribe({
      next: (response) => {
        return response;
      },
      error: (error) => {
        this.showError("Could not get presigned url for image.");
        return '';
      }
    });
  }

}
